'use client'

import { SplitsLink } from '~/components/Link'

// Docs-sourced intro for the create flow pages, ending in a link to the
// matching docs section.
export const CreatePageDescription = ({
  text,
  docsUrl,
}: {
  text: string
  docsUrl: string
}) => (
  <>
    {text}{' '}
    <SplitsLink path={docsUrl} target="tab" underline>
      Learn more
    </SplitsLink>
  </>
)
